export const EULA = [
    {
        name: 'Goverment US - 2023-01-06',
        category: 'goverment_us_20230601',
    },
];
